import { buildMonoPhrases, samplePlaybackRate } from './instrumentVoices';

export function isBassOneShotCategory(category) {
  const normalized = String(category || '').trim().toLowerCase();
  return normalized === '808' || normalized === 'bass';
}

export function samplerDefaultsForSound(sound) {
  const mono = isBassOneShotCategory(sound?.category);
  return {
    sampleId: typeof sound?.id === 'string' ? sound.id : null,
    rootNote: Number.isInteger(Number(sound?.rootNote)) ? Number(sound.rootNote) : 60,
    mono,
    glide: mono ? 80 : 0,
  };
}

export function samplerPhraseOutlastsBuffer(pattern, buffer, bpm) {
  if (!pattern?.mono || !buffer?.duration || !(Number(bpm) > 0)) return false;
  const rootRate = samplePlaybackRate({ pitch: pattern.rootNote, rootNote: pattern.rootNote, tune: pattern.tune, fine: pattern.fine });
  const sampleSeconds = buffer.duration / rootRate;
  const beatSeconds = 60 / Number(bpm);
  return buildMonoPhrases(pattern.notes, pattern.glide)
    .some((phrase) => (phrase.end - phrase.start) * beatSeconds > sampleSeconds);
}
